import React from "react";
import { useTranslation } from "react-i18next";

import { PageTitle } from "@components/shared";
import { AlertList } from "@components/Alert";
import entityIcon from "@util/entityIcon";
import entityColor from "@util/entityColor";

export default function AlertIndex() {
  const { t } = useTranslation();

  return (
    <div>
      <PageTitle
        title={t("alert_plural")}
        icon={entityIcon.alert()}
        iconColor={entityColor.engagement}
      />
      <AlertList />
    </div>
  );
}
